import { SectionField } from "types/Models/Filing";

type Values = Record<string, unknown>;

// Radio answers live in local state, other answers (e.g. selects) only in form values
export const isConditionMet = (
  field: Pick<SectionField, "radio">,
  radioValues: Values,
  values: Values
): boolean => {
  const condition = field.radio ?? {};
  const conditionKeys = Object.keys(condition);

  if (conditionKeys.length === 0) {
    return true;
  }

  return conditionKeys.some(
    (key) => (radioValues?.[key] ?? values?.[key]) === condition[key]
  );
};
